// ONE user-visible noun per freight party.
//
// The road-haulage partner was called an "Agent" in the sidebar and user admin,
// a "Transporter" in the conversation pane, "Transport" on the workspace lane
// and a "Hauler" on the stage checklist — four names for one company, so an
// operator could not tell whether four screens were about four different
// parties. "Transporter" wins because it is the word the data already uses
// (email templates are stored with `for: "transporter"`), so the text on screen
// and the record underneath finally agree.
//
// Import these instead of typing the noun again. DB enum values, API routes and
// code identifiers (savedAgents, /agents, agentPayable…) are deliberately left
// alone — this is a labelling fix, not a rename.

export const TRANSPORTER = "Transporter";
export const TRANSPORTERS = "Transporters";

/** The road leg itself rather than the company — e.g. a cost column heading. */
export const TRANSPORT_LEG = "Transport";
